// extracted by mini-css-extract-plugin
module.exports = {"fixedFooter":"FixedFooter_fixedFooter__LCzY0","iconsContainer":"FixedFooter_iconsContainer__3H_kA"};